import { DateTime } from "luxon";
import {
	TeamType,
	VirtualMeetingType
} from "@teaming/common-enums";

export const streamNoteTitleDate = () => DateTime.now().toFormat( "DD" ); // Nov 15, 2022

export const streamNoteLink = subDocId => `${ window.location.origin }${ window.location.pathname }?note=${ subDocId }`;

export const makeMarkMap = i18n => new Map( [
	[ TeamType.TEAM, i18n.global.t( "common-team.domain.teamMark" ), ],
	[ TeamType.ONE_ON_ONE, i18n.global.t( "common-team.domain.oneOnOneMark" ), ],
] );

const transcriptionAudioTypes = [
	".3ga",
	".8svx",
	".aac",
	".ac3",
	".aif",
	".aiff",
	".alac",
	".amr",
	".ape",
	".au",
	".dss",
	".flac",
	".flv",
	".m4a",
	".m4b",
	".m4p",
	".m4r",
	".mp3",
	".mpga",
	".ogg",
	".oga",
	".mogg",
	".opus",
	".qcp",
	".tta",
	".voc",
	".wav",
	".wma",
	".wv",
];

const transcriptionVideoTypes = [
	".webm",
	".MTS",
	".M2TS",
	".TS",
	".mov",
	".mp2",
	".mp4",
	".m4p",
	".m4v",
	".mxf",
];

/* @see https://www.assemblyai.com/docs#supported-file-types */
export const transcriptionFileTypes = Object.freeze( [ ...transcriptionVideoTypes, ...transcriptionAudioTypes, ] );

export const VirtualMeetingDomains = Object.freeze( {
	[ VirtualMeetingType.ZOOM ]: "zoom.us",
	[ VirtualMeetingType.MICROSOFT_TEAMS ]: "teams.microsoft.com",
	[ VirtualMeetingType.GOOGLE_MEET ]: "meet.google.com",
} );

export const resolveVirtualMeetingType = url => {
	try {
		const parsedURL = new URL( url );
		// needs to be a secure URL
		if ( !parsedURL.protocol.startsWith( "https" ) ) {
			return "";
		}
		// needs to have something after the domain
		if ( parsedURL.pathname === "/" ) {
			return "";
		}
		// needs to be within a supported virtual meeting domain
		for ( const [ key, domain, ] of Object.entries( VirtualMeetingDomains ) ) {
			if ( parsedURL.hostname.endsWith( domain ) ) {
				return key;
			}
		}
		return "";
	} catch ( e ) {
		return "";
	}
};
